import { OrderOut, OrdersResponse as OrdersApiResponse } from '../../store/api';
import { shopPrefix } from '../../config';
import { http } from '../axios';

const FETCH_ORDERS_URL = `${shopPrefix}/v1/orders`;

export type FetchOrdersResponse = {
    readonly orders: ReadonlyArray<OrderOut>;
    readonly totalCount: number;
};

type FetchOrdersParams = {
    readonly page?: number;
    readonly pageSize?: number;
    readonly sortBy?: string;
};

export const fetchOrders = ({ page, pageSize, sortBy }: FetchOrdersParams): Promise<FetchOrdersResponse> => {
    return http
        .get<OrdersApiResponse>(FETCH_ORDERS_URL, {
            params: {
                page, // e.g. 0,
                pageSize, // e.g. 50,
                sortBy // e.g. 'titleAZ'
            }
        })
        .then(response => {
            const fetchOrdersResponse: FetchOrdersResponse = {
                orders: response.data.orders ?? [],
                totalCount: response.data.totalCount ?? 0
            };
            return fetchOrdersResponse;
        });
};
